import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit, OnDestroy {
  currentSlide = 0;
  autoSlideInterval: any;

  resSlides = [
    { image: '../../../assets/images/IMG-1-carousel-home.png', alt: 'First slide' },
    { image: '../../../assets/images/IMG-2-carousel-home.png', alt: 'dummy slide' },
    { image: '../../../assets/images/IMG-3-carousel-home.png', alt: 'second slide' },
    { image: '../../../assets/images/IMG-4-carousel-home.png', alt: 'First slide' },
    { image: '../../../assets/images/IMG-5-carousel-home.png', alt: 'dummy slide' },
  ];

  slides = [
    { image: '../../../assets/images/landing-banner-1.jpg', alt: 'First slide' },
    { image: '../../../assets/images/landing-banner-2-1.jpg', alt: 'dummy slide' },
    { image: '../../../assets/images/landing-banner-3-2.jpg', alt: 'second slide' },
    { image: '../../../assets/images/landing-banner-4.jpg', alt: 'First slide' },
    { image: '../../../assets/images/landing-banner-5.jpg', alt: 'dummy slide' },
  ];

  quotes = [
    { p: 'Connecting Global Healthcare Innovators Under One Digital Roof' },
    { p: 'Redefining Healthcare Networking and Product Showcasing' },
    { p: 'Transforming Healthcare Expos with Cutting-Edge Digital Solutions' },
    { p: 'Empowering Medical Advancements Through Seamless Digital Collaboration' },
    { p: 'Your Gateway to Global Medical Equipment and Technology' },
  ];

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    this.stopAutoSlide(); // Stop auto sliding when the component is destroyed
  }

  startAutoSlide(): void {
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 2000); // Slides will auto-slide every 2 seconds
  }

  stopAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  goToSlide(index: number): void {
    this.stopAutoSlide();
    this.currentSlide = index;
    this.startAutoSlide();
  }

  prevSlide(): void {
    this.stopAutoSlide();
    this.currentSlide = this.currentSlide > 0 ? this.currentSlide - 1 : this.slides.length - 1;
    this.startAutoSlide();
  }

  nextSlide(): void {
    this.stopAutoSlide();
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.startAutoSlide();
  }
}
